$(document).ready(function () {
    // Header js start here
    $(document).on('click', '.js-hamburger-menu', function () {
        $(this).parents('.gm-header__wrap').find('.gm-header__right nav.mobile-nav').addClass('open-sidebar');
        $('body').addClass('scroll-hide')
    });
    $(document).on('click', '.js-icon-menu-close', function () {
        $(this).parents('.gm-header__wrap').find('.gm-header__right nav.mobile-nav').removeClass('open-sidebar');
        $('body').removeClass('scroll-hide')
    });
    $(document).on('click', '.js-mobile-sub-menu', function () {
        $('.gm-header__submenu').not($(this).parents('li').find('.gm-header__submenu')).slideUp();
        $('.gm-header__nav-link-wrap').not($(this).parents('li').find('.gm-header__nav-link-wrap')).removeClass('active');
        $(this).parents('li').find('.gm-header__submenu').slideToggle();
        $(this).parents('li').find('.gm-header__nav-link-wrap').toggleClass('active');
    });
    $(document).on('click', '.js-more-menu-btn', function () {
        $(this).parent('li').addClass('active');
    });

    // Header js end here

    // js-bm-uspa-slider Start Here
    if ($('.js-bm-uspa-slider').length > 0) {
        $('.js-bm-uspa-slider').slick({
            slidesToShow: 2.9,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            pauseOnHover: false,
            swipeToSlide: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
    // js-bm-uspa-slider End Here

    // js-bm-find-us-on-slider Start Here
    if ($('.js-bm-find-us-on-slider').length > 0) {
        $('.js-bm-find-us-on-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            pauseOnHover: false,
            swipeToSlide: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2.2,
                        slidesToScroll: 1,
                        speed: 3000,
                        autoplay: true,
                        autoplaySpeed: 0,
                        cssEase: "linear",
                    }
                }
            ]
        });
    }
    // js-bm-find-us-on-slider End Here

    // product-details slider start here
    if ($('.js-product-banner-main-slider').length > 0) {
        $('.js-product-banner-main-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            focusOnSelect: false,
            infinite: false,
            speed: 500,
            fade: true,
            asNavFor: '.js-product-banner-nav-slider',
            prevArrow: '<button type="button" class="prev-arrow"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="21" cy="21" r="20" fill="#202020" stroke="white" stroke-width="1.11111"/><path d="M19.4389 15.5928L14.0542 20.9774M14.0542 20.9774L19.4389 26.3621M14.0542 20.9774L27.9004 20.9774" stroke="white" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="next-arrow"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 41 1)" fill="#202020" stroke="white" stroke-width="1.11111"/><path d="M22.5611 15.5928L27.9458 20.9774M27.9458 20.9774L22.5611 26.3621M27.9458 20.9774L14.0996 20.9774" stroke="white" stroke-width="1.53846" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        infinite: true
                    }
                }
            ]
        });
    }
    if ($('.js-product-banner-nav-slider').length > 0) {
        $('.js-product-banner-nav-slider').slick({
            slidesToShow: 3.4,
            slidesToScroll: 1,
            arrows: false,
            focusOnSelect: true,
            infinite: false,
            asNavFor: '.js-product-banner-main-slider',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                        infinite: true
                    }
                }
            ]
        });
    }
    // product-details slider end here

    // js-bm-our-customers-slider Start Here
    let slider = $('.js-bm-our-customers-slider');
    let progressBar = $('.progress');
    let slidesToShow = 3.6;
    let sliderItemsWrap = $(document).find('.js-bm-our-customers-slider');
    let sliderItems = sliderItemsWrap.find('.slide').length;
    let progress;
    function handleResize() {
        if ($(window).width() >= 992) {
            slidesToShow = 3.6;
        } else if ($(window).width() >= 768) {
            slidesToShow = 2;
        } else {
            slidesToShow = 1.2;
        }
    }

    $(window).on('resize', function () {
        handleResize();
    });
    $(window).on('load', function () {
        progress = 100 / (sliderItems - slidesToShow + 1);
        progressBar.css('background-size', progress + '% 100%');
    });

    slider.slick({
        slidesToShow: 3.6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                }
            }
        ]
    });
    slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        progress = 100 / (sliderItems - slidesToShow + 1) * (currentSlide + 1);
        progressBar.css('background-size', progress + '% 100%');
    });
    // js-bm-our-customers-slider End Here

    // js-bm-advanced-heat-therapy-slider Start Here
    if ($('.js-bm-advanced-heat-therapy-slider').length > 0) {
        $('.js-bm-advanced-heat-therapy-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: true,
        });
    }
    // js-bm-advanced-heat-therapy-slider End Here

    // Related Products JS start here
    if ($('.js-related-products-slider').length > 0) {
        $('.js-related-products-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            prevArrow: $('.js-bm-related-products-prev'),
            nextArrow: $('.js-bm-related-products-next'),
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                    }
                }
            ]
        });
    }
    if ($('.js-related-products-slider .bm-related-products__slider-desc').length > 0) {
        $('.js-related-products-slider .bm-related-products__slider-desc').matchHeight({
            byRow: true,
        });
    }
    // Related Products JS End here

    // js-bm-shop-by-category-slider slick slider filter js start here
    function jobVacancies() {
        // Check if the slider element exists
        if ($('.js-bm-shop-by-category-slider').length > 0) {
            // Initialize the slider if not already initialized
            let relatedPostsSlider = $('.js-bm-shop-by-category-slider')
                .not('.slick-initialized')
                .slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    prevArrow: $('.js-bm-shop-by-category-prev'),
                    nextArrow: $('.js-bm-shop-by-category-next'),
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                                arrows: false,
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                arrows: false,
                            }
                        }
                    ]
                });

            function setFilter(filter) {
                relatedPostsSlider.slick('slickUnfilter'); // Remove existing filters
                relatedPostsSlider.slick('slickFilter', function () {
                    return $(this).data('category') === filter; // Filter based on category
                });
            }

            $(document).on('click', '.js-filter-button', function () {
                let filter = $(this).data('filter');
                $(this).addClass('active').siblings().removeClass('active');
                setFilter(filter);
            });
        }
    }
    jobVacancies();

    $(window).on('resize', function () {
        $('.js-bm-shop-by-category-slider.slick-initialized').slick('unslick');
        jobVacancies();
    });
    // js-bm-shop-by-category-slider slick slider filter js end here

    function cuttrLoad(){
        if ($('.bm-shop-by-category__slider-desc .product-name .product-title').length > 0) {
            $('.bm-shop-by-category__slider-desc .product-name .product-title').Cuttr({
                truncate: 'characters',
                length: 50
            });
        }
        if ($('.bm-related-products__slider-desc .product-name .product-title').length > 0) {
            $('.bm-related-products__slider-desc .product-name .product-title').Cuttr({
                truncate: 'characters',
                length: 50
            });
        }
    }
    
    var getElem = setInterval(function () {
        // Look for the element in the DOM
        var elem = document.querySelector('.bm-related-products__slider-desc .product-name .product-title, .bm-shop-by-category__slider-desc .product-name .product-title');
    
        // If the element is in the DOM, stop the interval and do something
        if (elem) {
            clearInterval(getElem);
            // cuttrLoad();
        }    
    }, 10);

   if ($('.product-banner__right .text-desc').length > 0) {
    
    $('.product-banner__right .text-desc')
        .addClass('pre-cuttr-hide');

    // Remove <p>
    $('.product-banner__right .text-desc p').contents().unwrap();

    $('.product-banner__right .text-desc').each(function() {

        const el = $(this);
        let cuttrLoaded = false; // Track if Cuttr ran

        el.Cuttr({
            truncate: 'characters',
            length: 300,
            readMore: true,
            readMoreText: 'See More',
            readLessText: 'See Less',
            readMoreBtnPosition: 'inside',
            ending: '...',

            afterExpand: function() {
                $(this).addClass("remove_line_clamp");
            },

            afterTruncate: function() {
                cuttrLoaded = true; // Mark as processed
                $(this).removeClass("remove_line_clamp pre-cuttr-hide");
            }
        });

        // Fallback for short text (Cuttr did not load)
        setTimeout(() => {
            if (!cuttrLoaded) {
                el.removeClass('pre-cuttr-hide').addClass('no-cuttr');
            }
        }, 2000);
    });
}


   if ($('.product-banner-premium__right .text-desc').length > 0) {
    
    $('.product-banner-premium__right .text-desc')
        .addClass('pre-cuttr-hide');

    // Remove <p>
    $('.product-banner-premium__right .text-desc p').contents().unwrap();

    $('.product-banner-premium__right .text-desc').each(function() {

        const el = $(this);
        let cuttrLoaded = false;

        el.Cuttr({
            truncate: 'characters',
            length: 300,
            readMore: true,
            readMoreText: 'See More',
            readLessText: 'See Less',
            readMoreBtnPosition: 'inside',
            ending: '...',

            afterExpand: function() {
                $(this).addClass("remove_line_clamp");
            },

            afterTruncate: function() {
                cuttrLoaded = true;
                $(this).removeClass("remove_line_clamp pre-cuttr-hide");
            }
        });

        // Fallback for short text
        setTimeout(() => {
            if (!cuttrLoaded) {
                el.removeClass('pre-cuttr-hide').addClass('no-cuttr');
            }
        }, 2000);
    });
}


    $('.js-scroll-to').on('click',function(e) {
        e.preventDefault();
        let splitURL = $(this).attr('href').toString().split('/')[1];
        if($(splitURL).length > 0) {
            if(splitURL.includes('#')) {
                $('html, body').animate({ scrollTop: $(splitURL).offset().top - 100 }, 1000);
            }
        }
    });

    // if ($('.product-banner-premium__right .text-desc').length > 0) {
    //     $('.product-banner-premium__right .text-desc').Cuttr({
    //         truncate: 'characters',
    //         length: 1000,
    //         readMore: true,
    //         readMoreText: 'See More',
    //         readLessText: 'See Less',
    //         readMoreBtnPosition: 'after',
    //         ending: '.',
    //         afterExpand: function(){
    //             let truncateElement = this;
    //             console.log(this);
    //             $(this).addClass("remove_line_clamp");
    //         },
    //         afterTruncate: function(){
    //             let truncateElement = this;
    //             console.log(this);
    //             $(this).removeClass("remove_line_clamp");
    //         }
    //     });
    // }

    if ($('.why-choose-us__box-content').length > 0) {
        $('.why-choose-us__box-content').matchHeight({
            byRow: true,
        });
    }
    if ($('.bm-our-customers__box .text-desc').length > 0) {
        $('.bm-our-customers__box .text-desc').matchHeight({
            byRow: true,
        });
    }
    if ($('.three-col-box__box').length > 0) {
        $('.three-col-box__box').matchHeight({
            byRow: true,
        });
    }
    if ($('.buying-online-benefits__box .text-desc').length > 0) {
        $('.buying-online-benefits__box .text-desc').matchHeight({
            byRow: true,
        });
    }

    // Accordian js Start here
    $(function () {
        $('.js-accordian-title').click(function (j) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parents('.cus-accordian').find('.cus-accordian__card').removeClass('active');
                $(this).next().slideUp();
            } else {
                $('.js-accordian-title').removeClass('active');
                $(this).parents('.cus-accordian').find('.cus-accordian__card').removeClass('active');
                $('.js-accordian-title').next().slideUp();
                $(this).addClass('active');
                $(this).parents('.cus-accordian__card').addClass('active');
                $(this).next().slideDown(function () {
                    $(this).css('display', 'block');
                });
            }

        });
    });
    // Accordian js End here

    $("a[download]").on("click", function (e) {
        e.preventDefault();

        let url = $(this).attr("href");
        if (url.indexOf('?v') > 0) {
            url = url.split('?v')[0];
        }

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch file: " + response.statusText);
                }
                return response.blob();
            })
            .then((blob) => {
                const tempLink = $("<a>")[0];
                tempLink.href = URL.createObjectURL(blob);
                tempLink.download = url.split("/").pop();
                tempLink.click();

                URL.revokeObjectURL(tempLink.href);
            })
            .catch((error) => {
                console.error("Error downloading file:", error);
            });
    });


    // New Js start here
    $(document).ready(function () {
        function waitForElement(selector, callback, intervalTime = 100, maxAttempts = 50) {
            let attempts = 0;
            let interval = setInterval(() => {
                if ($(selector).length > 0) {
                    clearInterval(interval);
                    callback();
                } else if (attempts >= maxAttempts) {
                    clearInterval(interval);
                    console.log(`Element ${selector} not found within time limit.`);
                }
                attempts++;
            }, intervalTime);
        }
    
        waitForElement('.cbb-frequently-bought-container.cbb-desktop-view, .cbb-frequently-bought-container.cbb-mobile-view', function () {
            console.log("Frequently bought container loaded!");
    
            $(".frequently-bought-together .frequently-bought-together__wrap").empty();
    
            setTimeout(() => {
                let totalPrice = 0;
                let productHtml = "";
    
                $(".cbb-frequently-bought-selector-list li").each(function () {
                    var productName = $(this).find(".cbb-frequently-bought-selector-label-name span, .cbb-frequently-bought-selector-label-name").last().text().trim();
                    var productPriceText = $(this).find(".cbb-frequently-bought-selector-label-sale-price .money").text().trim();
                    var productPrice = parseFloat(productPriceText.replace(/[^\d.]/g, "")) || 0;
                    var productLink = $(this).find("a.cbb-frequently-bought-selector-link").attr("href") || "#";
                    var productId = $(this).find(".cbb-frequently-bought-selector-input").attr('name') || '';
    
                    productHtml += `
                        <div class="frequently-bought-together__box">
                            <input type="checkbox" name="${productId}" class="js-select-product" id="frequently-bought-together-${productName}" checked data-price="${productPrice}">
                            <label for="frequently-bought-together-${productName}">
                                <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.34766 3.60901L4.0216 6.28295L8.47818 0.935059" stroke="white" stroke-width="1.33697" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </label>
                            <div class="product-box">
                                <figure class="js_image">
                                    <img src="" width="168" height="129">
                                </figure>
                                <h3>${productName}</h3>
                                <div class="price">
                                    <span>${productPriceText}</span>
                                </div>
                            </div>
                        </div>
                    `;
                    totalPrice += productPrice;
                });
    
                function updateTotalPrice() {
                    let updatedTotal = 0;
                    $(".js-select-product:checked").each(function () {
                        updatedTotal += parseFloat($(this).attr("data-price")) || 0;
                    });
    
                    $(".frequently-bought-together .price-box span").text(`$${updatedTotal.toFixed(2)}`);
                    console.log("Updated Total Price:", updatedTotal);
                }
    
                $(".frequently-bought-together .frequently-bought-together__wrap").append(productHtml);
    
                if (totalPrice > 0) {
                    var priceBox = `
                        <div class="frequently-bought-together__box price-box">
                            <p>Total price:</p>
                            <span>$${totalPrice.toFixed(2)}</span>
                            <button class="js-add-items">Add items</button>
                        </div>
                    `;
                    $(".frequently-bought-together .frequently-bought-together__wrap").append(priceBox);
                }
                updateTotalPrice();
                // Attach event listener for checkboxes
                $(document).on("change", ".js-select-product", function () {
                    updateTotalPrice();
                });
    
            }, 1000);
    
            setTimeout(() => {
                let parent = $('.cbb-frequently-bought-container');
                if (parent.length > 0) {
                    parent.find(".cbb-frequently-bought-product-image").each(function (index) {
                        var imageSrc = $(this).css("background-image");
    
                        if (imageSrc && imageSrc !== 'none') {
                            imageSrc = imageSrc.replace('url("', '').replace('")', '');
                            console.log(imageSrc);
                        } else {
                            console.log("No background image found.");
                            imageSrc = 'default-image.jpg';
                        }
    
                        $('.js_image img').eq(index).attr('src', imageSrc);
                    });
                } else {
                    console.log("Parent element not found.");
                }
            }, 2000);
        });
    });

    

    $(document).on('click', '.js-add-items', function(){
        $(".cbb-frequently-bought-add-button").trigger("click");
    });

    $(document).on("change", ".js-select-product", function () {
        $(this).parents('.frequently-bought-together__box').toggleClass("dissable", !this.checked);
    });
    $(document).on('click', '.js-select-product', function(){
        
        var clickedName = $(this).attr('name');
        
        if (clickedName) {
            $(".cbb-frequently-bought-selector-list li").each(function () {
                var checkbox = $(this).find("input[type='checkbox']");
                if (checkbox.attr('name') === clickedName) {                    
                    checkbox.trigger('click');
                }
            });
        }
        totalPriceFun();
    });
    
    
});